import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Grid, Link, Divider, Container, Typography, Stack, Box } from '@mui/material';
// routes
import { PATH_PAGE } from '../../routes/paths';
// components
import Logo from '../../components/Logo';
import SocialsButton from '../../components/SocialsButton';
import Image from '../../components/Image';

// ----------------------------------------------------------------------

const LINKS = [
  {
    headline: 'Morrex Group MMC',
    children: [
      { name: 'Azerbaycan Office', href: '#' },
      { name: 'BAKI ŞEHERİ, ZİYA BÜNYADOV PROSPEKTİ, 1965-Cİ MAHALLE ‘’ ÇINAR PARK ‘’ 503- A BLOK BAKU, AZERBAİJAN', href: '#' },
    ],
  },
  {
    headline: '',
    children: [
      { name: 'Terms and Condition', href: '#' },
      { name: '4 Levent , Tekven Tower , kat 7 no 469 Istanbul Turkey ', href: '#' },
      { name: 'Privacy Policy', href: '#' },
      { name: 'Privacy Policy', href: '#' },
      { name: 'Privacy Policy', href: '#' },
    ],
  },
  {
    headline: 'Contact',
    children: [
      { name: 'operation@morrexgroup.com', href: '#' },
      { name: 'Los Angeles, 359  Hidden Valley Road', href: '#' },
    ],
  },
];

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

export default function MainFooter() {
  return (
    <RootStyle>
      <Divider />
      <Container sx={{ pt: 10 }}>
        <Grid
          container
          justifyContent={{ xs: 'center', md: 'space-between' }}
          sx={{ textAlign: { xs: 'center', md: 'left' } }}
        >
          <Grid item xs={12} sx={{ mb: 3 }}>
            <Logo sx={{ mx: { xs: 'auto', md: 'inherit' } }} />
          </Grid>

          <Grid item xs={12} md={3} sx={{ mb: 3 }}>
            <Typography variant="body2" sx={{ pr: { md: 5 } }}>
              Morrex Group International Company has been operating since 2000. The company with its numerous active offices in various cities of Azerbaycan and Turkey are ready to serve all compatriots...
            </Typography>

            <Stack
              direction="row"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{ mt: 5, mb: { xs: 5, md: 0 } }}
            >
              <SocialsButton sx={{ mx: 0.5 }} />
            </Stack>
          </Grid>

          <Grid item xs={12} md={3} sx={{ mb: 3, pr: 3 }}>
            <Stack spacing={6} direction={{ xs: 'column', md: 'row' }} justifyContent="space-between">
            <Stack  spacing={2}>
                  <Typography component="p" variant="overline">
                  Morrex Group MMC
                  </Typography>
                  <Typography component="p" variant="overline" color='#ec008c'>
                  Azerbaycan Office
                  </Typography>
                      <Link
                      to={'#'}
                      color="inherit"
                      variant="body2"
                      component={RouterLink}
                      sx={{ display: 'block' }}
                    >
                      Baki Şehəri, Ziya Bünyadov Prospekti, 1965-ci Mahalle ‘’ Çınar Park ‘’ 503- A Blok Baku, Azerbaijan
                    </Link>
          <Image alt="logo" src="/logo/az.png" sx={{ maxWidth: 42 }} />

                </Stack>
            </Stack>
          </Grid>

          <Grid item xs={12} md={3} sx={{ mb: 3 }}>
            <Stack spacing={6} direction={{ xs: 'column', md: 'row' }} justifyContent="space-between">
            <Stack  spacing={2}>
                <br/>

                  <Typography component="p" variant="overline" color='#ec008c'>
                  China office
                  </Typography>
                  <Link
                      to={'#'}
                      color="inherit"
                      variant="body2"
                      component={RouterLink}
                      sx={{ display: 'block' }}
                    >
                      No 1619 Central Plaza , Jianshe Da RD Yuexiu District Guangzhou China
                    </Link>
                    <br/>
          <Image alt="logo" src="/logo/ch.png" sx={{ maxWidth: 50 }} />
                      {/* <Link
                      to={'#'}
                      color="inherit"
                      variant="body2"
                      component={RouterLink}
                      sx={{ display: 'block' }}
                    >
                      Tel: +994 51 7000 0445
                    </Link>
                    <Link
                      to={'#'}
                      color="inherit"
                      variant="body2"
                      component={RouterLink}
                      sx={{ display: 'block' }}
                    >
                      Tel: +90 542 309 47 81
                    </Link>
                    <Link
                      to={'#'}
                      color="inherit"
                      variant="body2"
                      component={RouterLink}
                      sx={{ display: 'block' }}
                    >
                      Mail:op1@morrexgroup.com
                    </Link>
                    <Link
                      to={'#'}
                      color="inherit"
                      variant="body2"
                      component={RouterLink}
                      sx={{ display: 'block' }}
                    >
                      Mail:op2@morrexgroup.com
                    </Link>
                    <Link
                      to={'#'}
                      color="inherit"
                      variant="body2"
                      component={RouterLink}
                      sx={{ display: 'block' }}
                    >
                      Web:www.morrexgroup.com
                    </Link> */}
                </Stack>
            </Stack>
          </Grid>

          <Grid item xs={12} md={3} sx={{ mb: 3 }}>
            <Stack spacing={6} direction={{ xs: 'column', md: 'row' }} justifyContent="space-between">
            <Stack  spacing={1}>
                  <br/>
                <Typography component="p" variant="overline" color='#ec008c'>
                Istanbul Office
                  </Typography>
                      <Link
                      to={'#'}
                      color="inherit"
                      variant="body2"
                      component={RouterLink}
                      sx={{ display: 'block' }}
                    >
                    Kuştepe, Mecidiyeköy Yolu Cd. No:12,Kat 4 daire 405  34381 Şişli/İstanbul
                    </Link>
                    <br/>
                    <br/>
          <Image alt="logo" src="/logo/tr.png" sx={{ maxWidth: 50 }} />

                </Stack>
            </Stack>
          </Grid>
        </Grid>

        <Typography
          component="p"
          variant="body2"
          sx={{
            mt: 10,
            pb: 5,
            fontSize: 13,
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          © 2021. All rights reserved
        </Typography>
      </Container>
    </RootStyle>
  );
}
